export const DOCUMENT_SECTIONS = [
  {
    id: "for_distributors",
    title: "Дистрибьюторам",
    link: "https://esd.docs-lab.ru/info/group/14/documents",
    image: require("../assets/for_distributors.png"),
  },
  {
    id: "presentation_materials",
    title: "Презентационные материалы",
    link: "https://esd.docs-lab.ru/info/group/3/documents",
    image: require("../assets/presentation_materials.png"),
  },
  {
    id: "agent_commission_plan",
    title: "План агентских вознаграждений",
    link: "https://esd.docs-lab.ru/info/group/4/documents",
    image: require("../assets/agent_commission_plan.png"),
  },
  {
    id: "licenses",
    title: "Лицензии",
    link: "https://esd.docs-lab.ru/info/group/5/documents",
    image: require("../assets/licenses.png"),
  },
  {
    id: "tsp_materials",
    title: "Работа с ТСП — материалы",
    link: "https://esd.docs-lab.ru/info/group/10/documents",
    image: require("../assets/tsp_materials.png"),
  },
  {
    id: "tsp_documents",
    title: "Работа с ТСП — документы",
    link: "https://esd.docs-lab.ru/info/group/13/documents",
    image: require("../assets/tsp_documents.png"),
  },
  {
    id: "legal",
    title: "Юридические документы",
    link: "https://esd.docs-lab.ru/info/group/6/documents",
    image: require("../assets/legal.png"),
  },
  {
    id: "international_direction",
    title: "Международное направление",
    link: "https://esd.docs-lab.ru/info/group/15/documents",
    image: require("../assets/english_materials.png"),
  },
  {
    id: "samo",
    title: "Инструкции и документы для работы с САМО",
    link: "https://esd.docs-lab.ru/info/group/9/documents",
    image: require("../assets/samo.png"),
  },
  {
    id: "rdo",
    title: "Русское Деловое Общество",
    link: "https://esd.docs-lab.ru/info/group/8/documents",
    image: require("../assets/rdo.png"),
  },
];

export const VIP_SECTIONS = ["tsp_materials", "tsp_documents"];
